import 'svg-innerhtml-polyfill';
import 'classlist-polyfill';
import 'core-js/actual/array/reduce';
import 'core-js/actual/array/concat';
import 'core-js/actual/object/keys';
import 'core-js/actual/object/assign';
import 'core-js/actual/array/includes';
import 'core-js/actual/array/at';
import 'core-js/actual/dom-collections/for-each';


// import "./main.scss";
import Products from "./Products.svelte";
import Inflation from "./Inflation.svelte";
import fragments from "../fragments.json";

const components = {
	"products": Products,
	"inflation": Inflation,
};

const devContainer = document.querySelector("#dev_container");

fragments.forEach((f) => {
	if (devContainer) {
		const c = document.createElement("div");
		c.id = f.containerId;
		if (f.class) c.classList.add("tslr-block-" + f.class);
		devContainer.appendChild(c);
	}

	const t = document.querySelector("#" + f.containerId);
	if (t)
		new components[f.name]({
			target: t,
			hydrate: true,
			intro: true,
		});
});
